import { IGamePlayMessages } from '@GFTypes/GameStoreTypes';

export type TGamePlayInformation = Partial<IGamePlayMessages> & { marqueText: boolean };

export const STATE_DEFAULTS: any = {
    marqueText: false,
    information: '',
    showInformation: false
};
